<div class="col-lg-12">
    <div class="call-to-act d-block text-center">
        <a class="btn btn-call-to-act text-center" (click)="applyOnline()">Apply Online</a>
    </div>
</div>